// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/compass-errors.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/compass-errors/compass-errors.js';

mount([g0]);
